// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { number, string, nullOrUndefined, boolean } from "@altostra/type-validations/lib/primitives";

export const isFreeTrialDevelopersTableResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      _id: string,
      email: string,
      first_name: string,
      last_name: string,
      full_name: string,
      department: string,
      image_url: string,
      authy_enabled: boolean,
      authy_id: nullOrUndefined,
      two_factor_auth_enabled: boolean,
      selected_tfa_flow_type: nullOrUndefined,
      braze_support_portal_access: boolean,
      subscribed_to_report: boolean,
      confirmed: boolean,
      last_signed_in_at: number,
      sign_in_count: nullOrUndefined,
      internal_role: objectOf({
        _id: string,
        name: string,
        created_at: number,
        granted_by: nullOrUndefined,
      }),
      additional_internal_permissions: arrayOf(nullOrUndefined),
      dismissed_banners: objectOf({}),
      banner_exposures: objectOf({}),
      company_id: string,
      is_suspended: boolean,
      is_company_admin: boolean,
      app_group_membership_count: number,
      id: string,
    })
  ),
});
